import styled from "styled-components"

export const StyledHomePage = styled.div`
    margin-top: 2rem;
`
